<template>
  <base-dialog class="field-setting-dialog" :visible.sync="visible" width="560px">
    <template #header>
      设置填写内容
    </template>
    <div class="row">
      <span class="tab">填写对象</span>
      <el-radio-group
        :value="btnInfo.refCid === '' ? '当前记录' : '关联记录'"
        @input="changeObjType"
      >
        <el-radio label="当前记录">当前记录</el-radio>
        <el-radio label="关联记录">关联记录（单条）</el-radio>
      </el-radio-group>
    </div>
    <template v-if="btnInfo.refCid !== ''">
      <normal-select
        :select-list="objOptions"
        :selected-item.sync="btnInfo.refCid"
        class="fill-select"
      ></normal-select>
    </template>
    <div class="row">
      <span class="tab">填写内容</span>
      <el-radio-group v-model="btnInfo.fillType" @change="clearContentSetting">
        <el-radio label="SELF">填写指定字段</el-radio>
        <el-radio label="CREATE_REF">新建并关联</el-radio>
      </el-radio-group>
    </div>
    <template v-if="btnInfo.fillType == 'SELF'">
      <el-button
        v-if="btnInfo.fillCids.length == 0"
        type="text"
        class="add-btn"
        @click="selectField"
        :disabled="btnInfo.refCid === null"
      >
        + 选择填写字段
      </el-button>
      <div v-else class="field-list">
        <div class="count">
          <span class="color-Gray_75">选择了{{ btnInfo.fillCids.length }}个字段</span>
          <span class="btn-change pLeft16" @click="selectField">
            <i class="el-icon-edit"></i>
            修改字段
          </span>
        </div>
        <el-tree
          v-show="btnInfo.fillCids.length"
          :data="btnInfo.fillCids"
          :props="{ children: 'subList' }"
          :expand-on-click-node="false"
          draggable
          :allow-drop="allowDrop"
          :allow-drag="allowDrag"
        >
          <div class="field-item" slot-scope="{ node, data }">
            <span v-tip class="name">
              <svg-icon
                v-if="node.level === 1"
                class="pointer"
                icon-class="svgo_drag"
                style="padding-right: 6px;"
              ></svg-icon>
              {{ fieldsInfoMap[data.cid] || "字段已删除" }}
            </span>
            <div class="actionList pointer">
              <span :class="{ active: data.type == 'R' }" @click="data.type = 'R'">
                只读
              </span>
              <span :class="{ active: data.type == 'W' }" @click="data.type = 'W'">
                填写
              </span>
              <span :class="{ active: data.type == 'H' }" @click="data.type = 'H'">
                必填
              </span>
            </div>
            <i class="el-icon-delete-solid pointer" @click="removeField(node, data)"></i>
          </div>
        </el-tree>
      </div>
    </template>
    <template v-else>
      <normal-select
        :select-list="contentOptions"
        :selected-item.sync="selectedContent"
        @update:selectedItem="contentSelect"
        class="fill-select-content"
      ></normal-select>
    </template>
    <template #footer>
      <base-button @click="visible = false">取 消</base-button>
      <base-button type="primary" @click="save" :disabled="disabledSave">保 存</base-button>
    </template>
    <select-fields
      ref="selectFields"
      :key="btnSheet.sheetId"
      :control-mapper="controlMapper"
      :level="0"
      @submit="updateFillFields"
    ></select-fields>
  </base-dialog>
</template>

<script>
import NormalSelect from "@/components/UIComponents/NormalSelect"
import SelectFields from "@/views/Company/Manage/Project/TaskTemplate/EditDialog/SelectFields"
import BaseDialog from "@/components/UIComponents/BaseDialog"
import BaseButton from "@/components/UIComponents/Button"
import { bfs } from "@/utils/algorithm"
import { getSheetInAvailableSheets } from "@/utils/sheet"

export default {
  name: "field-setting-dialog",
  components: {
    BaseDialog,
    SelectFields,
    NormalSelect,
    BaseButton
  },
  props: {
    sheetDef: Object,
    fieldsInfoMap: Object,
    availableSheets: Array
  },
  data() {
    return {
      visible: false,
      btnInfo: {
        fillCids: [],
        refCid: "", // "":填写自身 null:填写关联表尚未选择
        fillType: ""
      },
      selectedContent: ""
    }
  },
  computed: {
    btnSheet() {
      let refCid = this.btnInfo.refCid
      if (refCid === "") return this.sheetDef
      let refSheetId = this.sheetDef.controls.find(c => c._cid === refCid)?.refSheetId
      return getSheetInAvailableSheets(this.availableSheets, refSheetId) || {}
    },
    objOptions() {
      return (this.sheetDef.controls || [])
        .filter(i => i._type == "ref" && i.oneFlag)
        .map(i => ({ label: "[关联表] " + i.name, value: i._cid }))
    },
    contentOptions() {
      return (this.btnSheet.controls || [])
        .filter(i => i._type == "ref")
        .map(i => ({ label: "[关联表] " + i.name, value: i._cid }))
    },
    // 已经选择的字段cid数组
    hasSelected() {
      let selected = []
      bfs({
        arr: this.btnInfo.fillCids || [],
        childFuc: row => row.subList,
        cbk: row => {
          if (row._parent) selected.push(row._parent.cid + "_" + row.cid)
          else selected.push(row.cid)
        }
      })
      return selected
    },
    disabledSave() {
      if (this.btnInfo.refCid === "")
        return this.btnInfo.fillCids.length == 0 && this.selectedContent == ""
      else
        return (
          (this.btnInfo.fillCids.length == 0 && this.selectedContent == "") ||
          this.btnInfo.refCid == null
        )
    }
  },
  methods: {
    open(btnInfo) {
      this.btnInfo = Object.assign(
        { fillCids: [], refCid: "", fillType: "" },
        this._.cloneDeep(btnInfo)
      )
      if (btnInfo) {
        if (this.btnInfo.fillType == "CREATE_REF") {
          this.selectedContent = btnInfo.fillCids?.[0]?.cid
        }
      }
      this.visible = true
    },
    updateFillFields(cids) {
      let rowStateMap = {}
      bfs({
        arr: this.btnInfo.fillCids || [],
        childFuc: row => row.subList,
        cbk: row => {
          let { cid, _parent } = row
          let curCid = (_parent ? _parent._prefix : "") + cid
          row._prefix = curCid + "_"
          rowStateMap[curCid] = row.type
        }
      })
      let rowMap = {}
      cids
        .sort((a, b) => a.length - b.length)
        .forEach(cidStr => {
          let index = cidStr.lastIndexOf("_")
          if (index < 0) {
            rowMap[cidStr] = { cid: cidStr, type: rowStateMap[cidStr] || "W", subList: [] }
            return
          }
          let cid = cidStr.slice(index + 1)
          let prefix = cidStr.slice(0, index)
          let row = {
            cid: cid,
            type: rowStateMap[cidStr] || "W",
            subList: []
          }
          rowMap[cidStr] = row
          rowMap[prefix].subList.push(row)
        })
      this.btnInfo.fillCids = Object.keys(rowMap)
        .filter(cid => cid.length == 24)
        .map(cid => rowMap[cid])
    },
    changeObjType(type) {
      this.btnInfo.refCid = type === "当前记录" ? "" : null
      this.clearContentSetting()
    },
    clearContentSetting() {
      this.btnInfo.fillCids = []
      this.selectedContent = ""
    },
    contentSelect(value) {
      this.btnInfo.fillCids = [{ cid: value, type: "H" }]
    },
    save() {
      this.$emit("submit", this.btnInfo)
      this.visible = false
    },
    selectField() {
      this.$refs.selectFields.open(this.btnSheet.sheetId, this.hasSelected)
    },
    removeField(node, curRow) {
      const parent = node.parent
      const children = parent.data.subList || parent.data
      const index = children.findIndex(d => d.cid === curRow.cid)
      children.splice(index, 1)
    },
    controlMapper(control) {
      if (control._type == "ref") {
        if (!control.related) {
          control.isLeaf = true
        }
      }
      return control
    },
    allowDrop(draggingNode, dropNode, type) {
      return dropNode.level === 1 && ["next", "prev"].includes(type) // 允许第一级拖拽排序
    },
    allowDrag(draggingNode) {
      return draggingNode.level === 1 // 允许第一级拖拽排序
    }
  }
}
</script>

<style lang="scss" scoped>
.field-setting-dialog {
  .row {
    margin-top: 16px;
    .tab {
      font-size: 14px;
      color: #606266;
      margin-right: 30px;
    }
  }
  .fill-select {
    margin: 16px 10px 0 87px;
    height: 36px;
    width: 70%;
  }
  .fill-select-content {
    margin: 16px 10px 16px 87px;
    height: 36px;
    width: 70%;
  }
  .add-btn {
    margin-left: 87px;
    margin-top: 10px;
    margin-bottom: 10px;
    height: 36px;
    width: 70%;
    text-align: left;
    line-height: 36px;
    background: #f8f8f8;
    border-radius: 4px;
    padding: 0 17px;
    box-sizing: border-box;
    color: #2196f3;
    cursor: pointer;
    &:hover {
      background: #f5f5f5;
    }
  }
  .field-list {
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 13px;
    .el-tree {
      position: relative;
      left: -24px;
      margin-top: 10px;
      width: 540px;
    }
    ::v-deep {
      .el-tree-node {
        &:focus .el-tree-node__content {
          background-color: unset;
        }
        .el-tree-node__content {
          height: 36px;
          margin-bottom: 10px;
          &:hover {
            background-color: unset;
          }
        }
      }
    }
    .btn-change {
      color: #2196f3;
      cursor: pointer;
    }
    .field-item {
      flex: 1;
      display: flex;
      align-items: center;
      height: 36px;
      .name {
        flex: 1 1;
        padding: 0 12px;
        background: #f8f8f8;
        color: #333;
        border-radius: 4px;
        height: 36px;
        line-height: 36px;
      }
      .actionList {
        width: 160px;
        display: flex;
        margin: 0 10px 0 7px;
        box-sizing: border-box;
        background: #f8f8f8;
        span {
          color: #757575;
          line-height: 36px;
          display: inline-block;
          text-align: center;
          flex: 1 1;
          &.active {
            color: #2196f3;
          }
        }
      }
      .el-icon-delete-solid {
        padding: 3px;
        &:hover {
          color: #f44336;
        }
      }
    }
  }
}
</style>
